import * as actions from '../constants/actions';
import * as endpoints from '../constants/endpoints';
import {
  default as API,
  TAPIRequestCanceller,
  TAPIResponse
} from '../services/api';
import Logger from '../services/logger';

const log = new Logger('API ACTIONS');
const CACHE = true;
const PARAMS = {
  fields: '*',
  sort: {
    position: 1
  }
};

export default class Actions {
  public static get(dispatch, action, params?): TAPIRequestCanceller {
    dispatch({ type: actions[`${action}_PENDING`] });

    const canceller = API.newRequestCanceller();
    API.get(canceller, endpoints[`${action}_ENDPOINT`], params || PARAMS, CACHE, (e: Error, r: TAPIResponse) => {

      // Cancel request on completion (for cached responses).
      // Can also use the done message to check if request has finished.
      canceller.cancel('done');

      if (!!e) {
        log.error(e.message);
        dispatch({ type: actions[`${action}_REJECTED`], payload: e.message });
        return;
      }
      dispatch({ type: actions[`${action}_FULFILLED`], payload: r.data });
    });

    return canceller;
  }

  public static post(dispatch, action, params?): TAPIRequestCanceller {
    dispatch({ type: actions[`${action}_PENDING`] });

    const canceller = API.newRequestCanceller();
    API.post(canceller, endpoints[`${action}_ENDPOINT`], params || PARAMS, (e: Error, r: TAPIResponse) => {
      if (!!e) {
        log.error(e.message);
        dispatch({ type: actions[`${action}_REJECTED`], payload: e.message });
        return;
      }
      dispatch({ type: actions[`${action}_FULFILLED`], payload: r.data });
    });

    return canceller;
  }

  public static requestFinished(canceller: TAPIRequestCanceller): boolean {
    if (!canceller) return false;
    const token = canceller.token;
    const hasMessage = token && token.reason && token.reason.message;
    return !!(hasMessage && token.reason && token.reason.message === 'done');
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.ts